var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import _ from 'lodash';
import { getImageDimensions, saveImageToBase64 } from 'ziphy-web-shared/basic/helpers';
import { UserPhoto } from 'ziphy-web-shared/basic/lib/simple';
import { showAlert } from 'ziphy-web-shared/basic/lib/utilities';
import styles from './UploadAvatar.module.scss';
const UploadAvatar = ({ user, field, sizeMax = 100, // KB
widthMax = 500, // px
heightMax = 500, // px
 }) => {
    const { t } = useTranslation();
    const { value, onChange } = field;
    const handleOnChange = (e) => __awaiter(void 0, void 0, void 0, function* () {
        let file = _.get(e, 'target.files[0]');
        let result;
        const { width, height } = yield getImageDimensions(file);
        if (file) {
            result = yield saveImageToBase64(file);
        }
        if (file.size > sizeMax * 1000) {
            return showAlert.error(t('alert.size_must_be_KB_maximum', { sizeMax }));
        }
        if (width > widthMax || height > heightMax) {
            return showAlert.error(t('alert.dimensions_must_be_px_maximum', { widthMax, heightMax }));
        }
        onChange(result);
    });
    // TODO Needed?
    // function removeAvatar(e) {
    //   confirmAction(
    //     'customAlert',
    //     {
    //       data: {
    //         title: t('profile_edit.photo.remove_alert.title'),
    //         message: t('profile_edit.photo.remove_alert.message'),
    //         done: t('btn.delete'),
    //         cancel: t('btn.cancel'),
    //       },
    //       callback: async () => await handleOnChange(''),
    //     },
    //     e,
    //   )
    // }
    return (_jsxs("div", Object.assign({ className: classNames(styles.container, 'mb-30') }, { children: [_jsx("label", Object.assign({ className: styles.label, htmlFor: "upload_photo-field" }, { children: value ? (_jsxs(_Fragment, { children: [_jsx(UserPhoto, { item: Object.assign(Object.assign({}, user), { avatar: value }), mode: 'lg' }), _jsx("div", Object.assign({ className: styles.button }, { children: t('btn.change_photo') }))] })) : (_jsxs(_Fragment, { children: [user.firstName || user.lastName ? (_jsx(UserPhoto, { item: Object.assign(Object.assign({}, user), { avatar: value }), mode: 'lg' })) : (_jsx("div", { className: styles.add })), _jsx("div", Object.assign({ className: styles.button }, { children: t('btn.add_photo') }))] })) })), _jsx("input", { type: "file", accept: "image/*", id: "upload_photo-field", onChange: handleOnChange })] })));
};
export default UploadAvatar;
